import { render, staticRenderFns } from "./BaseEditor.vue?vue&type=template&id=674743be"
import script from "./BaseEditor.vue?vue&type=script&lang=js"
export * from "./BaseEditor.vue?vue&type=script&lang=js"
import style0 from "./BaseEditor.vue?vue&type=style&index=0&id=674743be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports